import React, { useState } from "react";
import GraphicsList from "./GraphicsList";
import GraphicsModal from "./GraphicsModal";
import { GraphicsItem } from "./api";
import { useT } from "../../i18n";

const GraphicsManagement: React.FC = () => {
  const t = useT();
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editItem, setEditItem] = useState<GraphicsItem | null>(null);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleAddNew = () => {
    setEditItem(null);
    setIsModalOpen(true);
  };

  const handleEditItem = (item: GraphicsItem) => {
    setEditItem(item);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditItem(null);
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              {t("graphics.title")}
            </h1>
            <p className="text-gray-600 mt-1">
              {t("graphics.subtitle")}
            </p>
          </div>
          <button
            onClick={handleAddNew}
            data-testid="add-graphics-btn"
            className="px-4 py-2 bg-[#111827] text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium flex items-center"
          >
            <i className="fa-solid fa-plus mr-2"></i>
            {t("graphics.addGraphics")}
          </button>
        </div>
      </div>

      {/* Graphics List */}
      <GraphicsList
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        onEditItem={handleEditItem}
      />

      {/* Graphics Modal */}
      <GraphicsModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        editItem={editItem}
      />
    </div>
  );
};

export default GraphicsManagement;
